// src/context/ToastContext.js
import React, { createContext, useState, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid'; // 1. Importar a biblioteca
import ToastContainer from '../components/common/Toast/ToastContainer';

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  // Usamos useCallback para evitar recriações desnecessárias da função
  const addToast = useCallback((message, type = 'success') => {
    const id = uuidv4(); // 2. Usar UUID para garantir um ID único
    setToasts((prevToasts) => [...prevToasts, { id, message, type }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prevToasts) => prevToasts.filter(toast => toast.id !== id));
  }, []);

  const value = { addToast };

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </ToastContext.Provider>
  );
};